import React from 'react';
import './Layout.scss';
import Header from '../header/Header';
import { Outlet } from 'react-router-dom';
import Footer from '../footer/Footer';
function Layout({lang,t,changeLanguages}) {
  return (
    <>
      <Header lang={lang} t={t} changeLanguages={changeLanguages}/> {/*languageselect вот тут и он вместе с хедером передается вем компонентам */}
      <Outlet/>
      <Footer t={t}/>
    </>
  );
}

export default Layout;